import registeredFunctions from './registeredFunctions'

export function registerFilterChipsFunction(id, fn) {
    registeredFunctions[id] = fn
}

export function getFilterChips() {
    return Object.values(registeredFunctions)
        .map((fn) => {
            const result = fn()
            if (Array.isArray(result)) {
                return result
            }
            return [result]
        })
        .flatten()
        .filter((f) => !!f)
}
